const TOKEN_KEY = 'access-token';

export function migrateLegacySessionToken() {
  const localToken = localStorage.getItem(TOKEN_KEY);
  if (localToken) {
    return localToken;
  }

  const legacyToken = sessionStorage.getItem(TOKEN_KEY);
  if (legacyToken) {
    localStorage.setItem(TOKEN_KEY, legacyToken);
    sessionStorage.removeItem(TOKEN_KEY);
    return legacyToken;
  }

  return '';
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || migrateLegacySessionToken() || '';
}

export function setToken(token) {
  if (!token) {
    clearToken();
    return '';
  }

  localStorage.setItem(TOKEN_KEY, token);
  sessionStorage.removeItem(TOKEN_KEY);
  return token;
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
}



// WEBPACK FOOTER //
// ./src/util/auth.js